<ng-container *ngIf="companyInfo$ | async as company">
    <div class="Vert-20"></div>
    <div class="company-footer row" *ngIf="branding$ | async as branding">

        <div class="col-xl-12">

            <div class="row" *ngIf="(lgvCompanySvc.getFooterLogoAsset$(branding$) | async) || (company.companySocialMedia && company.companySocialMedia.length > 0)">
                <div class="col-xl-4 col-lg-12 logo">
                    <a class="logo" [href]="company.website" target="_blank"><img [src]="this.lgvCompanySvc.getFooterLogoAsset$(branding$) | async" /></a><br />
                </div>
                <div class="col-xl-4">&nbsp;</div>

                <!--social media-->
                <div class="col-xl-4 col-lg-12">
                    <ul class="menu">
                        <li *ngFor="let sm of company.companySocialMedia" class="social-media">
                            <a [href]="sm.url" target="_blank"><lgv-social-media-icon [socialMediaType]="sm.socialMediaTypeId" [iconClass]="'fa-lg'" title="Follow {{company.name}} on {{socialMediaNameFromID(sm.socialMediaTypeId)}}"></lgv-social-media-icon></a>
                        </li>
                    </ul>
                </div>
                <div class="Vert-30"></div>
            </div>
            
            <div class="row">
                <div class="col-12" style="padding-left:25px;">
                    {{company.name}}<br />
                    <span *ngIf="company.address1">{{company.address1}},</span> {{company.city}}, {{company.state}} {{company.zipCode}}<br />
                    <div class="Vert-20"></div>
                </div>


                <div class="col-12" style="padding-left:25px;">
                    <lgv-company-copyright [companyInfo]="company"></lgv-company-copyright>
                </div>

                <div class="Vert-20"></div>

                <div class="col-12">
                    <div class="Vert-15"></div>
                    <ul class="menu centered">

                        <ng-container *ngIf="(isMortgageCompany$ | async) && !!company.nmlsid">

                            <ng-container *ngIf="(lgvCompanySvc.isDarkFooterBkg$ | async) then IsDarkBkg else IsNotDarkBkg">
                            </ng-container>

                            <ng-template #IsDarkBkg>
                                <li>
                                    <img alt="Equal Housing Opportunity" src="https://hdprodwestst.blob.core.windows.net/shared-images/eho-white.png" height="37" style="margin-top:-10px;">
                                </li>
                            </ng-template>
                            <ng-template #IsNotDarkBkg>
                                <li>
                                    <img alt="Equal Housing Opportunity" src="https://hdprodwestst.blob.core.windows.net/shared-images/eho-black.png" height="37" style="margin-top:-10px;">
                                </li>
                            </ng-template>
                        </ng-container>

                        <!--Footer Link Disclaimers-->
                        <ng-container *ngFor="let disc of linkFooterDisclosures$ | async">
                            <li><a [href]="disc.value" target="_blank">{{disc.title}}</a></li>
                        </ng-container>
                    </ul>

                </div>

                <div class="Vert-15"></div>

                <!--Footer Text Disclaimers-->
                <ng-container *ngFor="let disc of textFooterDisclosures$ | async">
                    <div class="col-12 textDisclosure centered"><small>{{disc.value}}</small></div>
                </ng-container>

            </div>
        </div>


    </div>
</ng-container>


<div class="Vert-15"></div>
